import script from "./SideBarPublishingPanel.vue?vue&type=script&setup=true&lang=js"
export * from "./SideBarPublishingPanel.vue?vue&type=script&setup=true&lang=js"

import "./SideBarPublishingPanel.vue?vue&type=style&index=0&id=583ff20a&scoped=true&lang=css"

import exportComponent from "/opt/build/repo/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-583ff20a"]])

export default __exports__